export type Random = {
  getRandomValues: (b: Uint8Array<ArrayBuffer>) => Uint8Array
}

// IDs only request byte arrays; normalize DOM and React Native overloads here.
export const cryptoRandom: Random = {
  getRandomValues: (array) => crypto.getRandomValues(array),
}
